import PeopleIcon from "@mui/icons-material/People";
import BankerCreate from "./BankerCreate";
import BankerEdit from "./BankerEdit";
import BankerList from "./BankerList";

export default {
  list: BankerList,
  create: BankerCreate,
  edit: BankerEdit,
  icon: PeopleIcon,
};
